'use strict';

var ScenarioFactory = function ScenarioFactory(momentService) {
  function Scenario(displayName, createdBy, reoptStatus, creationDate, lastUpdated, ruleRefs) {
    this.createdBy = createdBy;
    this.creationDate = creationDate || momentService.now(momentService.FIELD.CREATED_AT).toISOString();
    this.reoptStatus = reoptStatus;
    this.displayName = displayName;
    this.lastUpdated = lastUpdated || momentService.now(momentService.FIELD.LAST_UPDATED_AT).toISOString();
    this.ruleRefs = ruleRefs || [];
  }
  Scenario.prototype.fromResponse = function (response) {
    this.id = response.id;
    this.createdBy = response.createdBy;
    this.creationDate = response.creationDate;
    this.lastUpdated = response.lastUpdated;
    this.scenarioName = response.scenarioName;
    this.reoptStatus = response.reoptStatus;
    this.ruleRefs = response.ruleRefs;
    this.displayName = response.displayName;
  };
  return Scenario.bind(this);
};
ScenarioFactory.$inject = ['MomentService'];
module.exports = ScenarioFactory;